module.exports = __webpack_public_path__ + "img/Ortsfest.5f720157.svg";